var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { reportService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var BehaviourControlService = /** @class */ (function () {
    function BehaviourControlService() {
    }
    /**
     * 查询行为过程监控表
     */
    BehaviourControlService.prototype.getBehavioralProcess = function (data, loading) {
        var model = Object.assign({}, data);
        var userIds = (model.userIds || []).join();
        return this.netService.send({
            server: reportService.reportController.getBehavioralProcess,
            data: {
                departCode: data.departCode,
                userIds: userIds,
                type: data.type,
                startDate: data.start,
                endDate: data.end
            },
            loading: loading
        });
    };
    /**
     * 导出行为过程监控表
     */
    BehaviourControlService.prototype.exportBehavioralProcess = function (data, loading) {
        var model = Object.assign({}, data);
        var userIds = (model.userIds || []).join();
        return this.netService.send({
            server: reportService.reportController.exportBehavioralProcess,
            data: {
                departCode: data.departCode,
                userIds: userIds,
                type: data.type,
                startDate: data.start,
                endDate: data.end
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], BehaviourControlService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], BehaviourControlService.prototype, "getBehavioralProcess", null);
    __decorate([
        Debounce()
    ], BehaviourControlService.prototype, "exportBehavioralProcess", null);
    return BehaviourControlService;
}());
export { BehaviourControlService };
